// extracted by mini-css-extract-plugin
export default {"button":"Button_button__6Y1h1","button_disabled":"Button_button_disabled__JIz44","button_loading":"Button_button_loading__mUKSe","button_index":"Button_button_index__s2lmJ"};